import { IoFilterSharp } from "react-icons/io5";
import { useFilters } from "../../context/FiltersContext";

const categories = [
  "men's clothing",
  "jewelery",
  "electronics",
  "women's clothing",
];

const FiltersGroup = () => {
  const {
    category,
    setCategory,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
  } = useFilters();

  return (
    <div className="filters-container">
      <div>
        <IoFilterSharp />
        <h2>Filters</h2>
      </div>

      <div>
        <h3>Category</h3>
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="">All</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div>
        <h3>Price Range</h3>

        <input
          type="range"
          min="0"
          max="1000"
          value={minPrice}
          onChange={(e) => setMinPrice(Number(e.target.value))}
        />
        <span>Min: ${minPrice}</span>

        <input
          type="range"
          min="0"
          max="1000"
          value={maxPrice}
          onChange={(e) => setMaxPrice(Number(e.target.value))}
        />
        <span>Max: ${maxPrice}</span>
      </div>
    </div>
  );
};

export default FiltersGroup;
